import React from 'react'
import Box from '@mui/material/Box'
import { alpha } from '@mui/material/styles'
import theme from '../../theme'

type VoucherStateBadgeProps = {
  state: string
}

type StateStyle = { color: string; bg: string; outlined?: boolean }

const STATE_STYLES: Record<string, StateStyle> = {
  DRAFT: {
    color: theme.palette.text.secondary,
    bg: 'transparent',
    outlined: true,
  },
  SUBMITTED: {
    color: theme.palette.text.secondary,
    bg: alpha(theme.palette.text.secondary, 0.12),
  },
  IN_PROGRESS: {
    color: theme.palette.warning.main,
    bg: alpha(theme.palette.warning.main, 0.14),
  },
  APPROVED: {
    color: theme.palette.info.main,
    bg: alpha(theme.palette.info.main, 0.12),
  },
  PAID: {
    color: theme.palette.success.main,
    bg: alpha(theme.palette.success.main, 0.12),
  },
  REJECTED: {
    color: theme.palette.error.main,
    bg: alpha(theme.palette.error.main, 0.12),
  },
}

const VoucherStateBadge: React.FC<VoucherStateBadgeProps> = ({ state }) => {
  const style = STATE_STYLES[state] ?? STATE_STYLES.SUBMITTED

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        fontSize: '0.82rem',
        fontWeight: 600,
        lineHeight: 1,
        px: 1.4,
        py: 0.7,
        borderRadius: 10,
        color: style.color,
        bgcolor: style.bg,
        border: style.outlined ? '1px solid' : 'none',
        borderColor: 'divider',
        whiteSpace: 'nowrap',
      }}
    >
      <Box
        component="span"
        sx={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          bgcolor: style.color,
          flexShrink: 0,
        }}
      />
      {state}
    </Box>
  )
}

export default VoucherStateBadge
